"use strict";
/*
 * Created on 10 14 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var AppModule_1 = require("../core/modules/AppModule");

var SimpleExportedEntityConverter_1 = require("./conversions/simple-export/SimpleExportedEntityConverter");

var SimpleExportedEntityConverterImpl_1 = require("./conversions/simple-export/SimpleExportedEntityConverterImpl");

var SimpleExportedEntityPublicConverter_1 = require("./conversions/simple-export/SimpleExportedEntityPublicConverter");

var SimpleExportedEntityPublicConverterImpl_1 = require("./conversions/simple-export/SimpleExportedEntityPublicConverterImpl");
/**
 * @author Jaroslav Sevcik
 */


var ExportAppModule =
/*#__PURE__*/
function (_AppModule_1$AppModul) {
  _inherits(ExportAppModule, _AppModule_1$AppModul);

  function ExportAppModule() {
    var _this;

    _classCallCheck(this, ExportAppModule);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ExportAppModule).apply(this, arguments));
    /**
     * @inheritDoc
     */

    _this.name = 'exportAppModule';
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(ExportAppModule, [{
    key: "configure",
    value: function configure() {
      typescript_ioc_1.Container.bind(SimpleExportedEntityConverter_1.SimpleExportedEntityConverter).to(SimpleExportedEntityConverterImpl_1.SimpleExportedEntityConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(SimpleExportedEntityPublicConverter_1.SimpleExportedEntityPublicConverter).to(SimpleExportedEntityPublicConverterImpl_1.SimpleExportedEntityPublicConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
    }
  }]);

  return ExportAppModule;
}(AppModule_1.AppModule);

exports.ExportAppModule = ExportAppModule;